import React from 'react';
export function TopBar() {
  return <div className="bg-brand-900 text-white text-center py-2 px-4 text-sm font-medium sticky top-0 z-50" data-id="element-198">
      Oferta por tiempo limitado · Quedan pocos cupos
    </div>;
}